// 10 dedicated service pages — Arabic-first content with English
// counterparts. Each entry powers a /services/<slug> route plus the
// /services index grid. Icons come from lucide-react.

export const SERVICES = [
  {
    slug: "family-law",
    icon: "Heart",
    titleAr: "الأحوال الشخصية",
    titleEn: "Family & Personal Status",
    seoTitleAr: "محامي أحوال شخصية في الكويت | طلاق، حضانة، نفقة، ميراث",
    seoTitleEn: "Family Law in Kuwait | Divorce, Custody, Alimony, Inheritance",
    metaAr:
      "محامٍ متخصص في الأحوال الشخصية في الكويت: قضايا الطلاق والحضانة والنفقة والميراث وتثبيت الزواج وعضل الولي. استشارة سرية مع مجموعة الدخيل القانونية.",
    metaEn:
      "Specialist family lawyer in Kuwait covering divorce, custody, alimony, inheritance, and marriage validation under Law 51 of 1984.",
    teaserAr:
      "نتعامل مع قضايا الأحوال الشخصية بأقصى درجات السرية ومراعاة خصوصية الأسرة الخليجية.",
    teaserEn:
      "Personal status matters handled with the highest discretion and respect for GCC family structures.",
    introAr:
      "تتشعّب نزاعات الأحوال الشخصية في الكويت بين قانون الأحوال الشخصية رقم 51 لسنة 1984، وأحكام الشريعة الإسلامية، ومبادئ محكمة التمييز المستقرة. نقدّم لك ولأسرتك دفاعاً سرياً ومدروساً يحفظ الحقوق ويقلّل الضرر.",
    introEn:
      "Personal status disputes in Kuwait sit at the intersection of Law 51 of 1984, Islamic Sharia, and the settled jurisprudence of the Court of Cassation. We deliver discreet, considered representation.",
    includesAr: [
      "دعاوى الطلاق والخلع والتفريق للضرر",
      "إثبات الحضانة وإسقاطها والمحافظة على الصغير",
      "النفقة الزوجية ونفقة الأبناء والأقارب",
      "تقسيم التركات والإرث وتنفيذ الوصايا",
      "إثبات الزواج وتوثيق العقود",
      "عضل الولي والإذن بالزواج",
      "الرؤية ودعاوى الاستضافة",
    ],
    includesEn: [
      "Divorce, khul', and judicial separation",
      "Custody establishment, removal, and child protection",
      "Spousal, child, and relative maintenance",
      "Estate division, inheritance, and will execution",
      "Marriage validation and contract registration",
      "Wali refusal and judicial marriage permission",
      "Visitation and access disputes",
    ],
    documentsAr: [
      "البطاقة المدنية وجوازات السفر",
      "وثيقة الزواج وعقد المهر",
      "شهادات ميلاد الأبناء",
      "كشوف الرواتب والمستندات المالية",
      "أي محاضر شرطة أو تقارير طبية سابقة",
    ],
    documentsEn: [
      "Civil ID and passports",
      "Marriage certificate and dowry contract",
      "Children's birth certificates",
      "Salary statements and financial records",
      "Any prior police reports or medical evidence",
    ],
    processAr: [
      { step: "1", title: "استشارة سرية أولية", body: "نستمع لتفاصيل القضية ونقيّم الموقف خلال 30 دقيقة." },
      { step: "2", title: "إعداد الملف القانوني", body: "نجمع المستندات، نحرّر المذكرات، ونحدد الاستراتيجية." },
      { step: "3", title: "التمثيل أمام المحاكم", body: "نحضر جميع الجلسات أمام محكمة الأسرة وحتى التمييز." },
      { step: "4", title: "متابعة التنفيذ", body: "نتابع تنفيذ الحكم، تحصيل النفقات، وضمان احترام الحقوق." },
    ],
    processEn: [
      { step: "1", title: "Confidential consultation", body: "30-minute private review of facts and objectives." },
      { step: "2", title: "Build the file", body: "Document gathering, drafting, and strategy." },
      { step: "3", title: "Court representation", body: "All hearings from first instance to Cassation." },
      { step: "4", title: "Execution & follow-up", body: "Judgment execution, maintenance collection, enforcement of rights." },
    ],
    faqAr: [
      { q: "متى تستحق الزوجة النفقة؟", a: "تستحق الزوجة النفقة من تاريخ عقد الزواج الصحيح متى كانت في عصمة الزوج وامتنع عن الإنفاق. تحدد المحكمة قيمتها بحسب يسار الزوج وعرف البلد." },
      { q: "متى تسقط الحضانة؟", a: "تسقط الحضانة وفق قانون الأحوال الشخصية في حالات منها: الزواج بأجنبي عن الصغير، عدم الأمانة، الإعاقة عن الحضانة، تعريض المحضون لخطر، أو الإهمال الجسيم." },
      { q: "هل يمكن التوكيل عن بُعد؟", a: "نعم، عبر توكيل عام مصدّق من السفارة الكويتية أو الخارجية، أو توكيل خاص محرر داخل الكويت." },
    ],
    faqEn: [
      { q: "When is a wife entitled to maintenance?", a: "From the date of a valid marriage if the husband fails to provide. Court fixes amount based on his financial capacity." },
      { q: "When does custody fall?", a: "Under Law 51/1984, causes include: remarriage to a stranger, unfitness, disability, endangerment, or gross neglect." },
      { q: "Can I appoint counsel remotely?", a: "Yes — via a power of attorney attested by the Kuwaiti embassy or executed within Kuwait." },
    ],
  },
  {
    slug: "labor-law",
    icon: "Briefcase",
    titleAr: "القضايا العمالية",
    titleEn: "Labor & Employment",
    seoTitleAr: "محامي قضايا عمالية في الكويت | فصل تعسفي، نهاية خدمة، حقوق العمال",
    seoTitleEn: "Kuwait Labor Lawyer | Unfair Dismissal, End-of-Service, Worker Rights",
    metaAr:
      "متخصصون في قانون العمل الكويتي رقم 6 لسنة 2010: الفصل التعسفي، نهاية الخدمة، الإجازات، البدلات، إصابات العمل. تمثيل العامل وصاحب العمل.",
    metaEn:
      "Kuwait labor law specialists under Law 6 of 2010 — unfair dismissal, end-of-service, allowances, work injuries. We represent employees and employers.",
    teaserAr: "حماية كاملة لحقوقك العمالية وفق قانون العمل الكويتي رقم 6 لسنة 2010.",
    teaserEn: "Complete protection of your employment rights under Kuwait Labor Law 6 of 2010.",
    introAr:
      "ينظّم قانون العمل الكويتي رقم 6 لسنة 2010 العلاقة بين العامل وصاحب العمل في القطاع الخاص. نتعامل مع نزاعات الفصل، احتساب نهاية الخدمة، البدلات، الإجازات، وإصابات العمل أمام الهيئة العامة للقوى العاملة والمحاكم العمالية.",
    introEn:
      "Kuwait Labor Law No. 6 of 2010 governs private-sector employment. We handle dismissal, end-of-service calculations, allowances, and work-injury claims before the Public Authority for Manpower and the labor courts.",
    includesAr: [
      "الفصل التعسفي والمطالبة بالتعويض",
      "احتساب نهاية الخدمة بدقة",
      "بدلات الإجازات والسفر والسكن",
      "إصابات العمل وأمراض المهنة",
      "تحويل الكفالة وأذونات العمل",
      "خصومات وأجور متأخرة",
      "صياغة ومراجعة عقود العمل",
    ],
    includesEn: [
      "Unfair dismissal and compensation claims",
      "Precise end-of-service computation",
      "Leave, travel, and housing allowances",
      "Work injuries and occupational illness",
      "Sponsorship transfers and work permits",
      "Deductions and unpaid wages",
      "Employment contract drafting & review",
    ],
    documentsAr: [
      "عقد العمل والملاحق",
      "بطاقة العمل وإذن العمل",
      "كشوف الرواتب آخر 12 شهراً",
      "خطاب الإنهاء (إن وجد)",
      "أي مراسلات إلكترونية ذات صلة",
    ],
    documentsEn: [
      "Employment contract and addenda",
      "Work card and labor permit",
      "Pay slips for the last 12 months",
      "Termination letter (if any)",
      "Relevant email correspondence",
    ],
    processAr: [
      { step: "1", title: "تقييم الموقف", body: "تحديد طبيعة النزاع وحجم المستحقات الفعلية." },
      { step: "2", title: "الشكوى الإدارية", body: "تقديم شكوى لدى الهيئة العامة للقوى العاملة ومتابعتها حتى إحالتها." },
      { step: "3", title: "الدعوى العمالية", body: "إقامة الدعوى أمام المحكمة العمالية مع كافة المطالبات." },
      { step: "4", title: "التنفيذ والتحصيل", body: "تنفيذ الحكم وتحصيل المستحقات." },
    ],
    processEn: [
      { step: "1", title: "Assessment", body: "Identify the dispute type and your true entitlement." },
      { step: "2", title: "Administrative complaint", body: "File with the Public Authority for Manpower and follow up until referral." },
      { step: "3", title: "Labor lawsuit", body: "File before the labor court with all claims consolidated." },
      { step: "4", title: "Enforcement", body: "Execute the judgment and collect entitlements." },
    ],
    faqAr: [
      { q: "ما حقوق العامل عند الفصل التعسفي؟", a: "يستحق العامل مكافأة نهاية الخدمة كاملة وبدل رصيد الإجازات، وتعويضاً عن الفصل التعسفي تقدّره المحكمة وفق المادة 46 من قانون العمل." },
      { q: "كيف تُحتسب نهاية الخدمة؟", a: "وفق المادة 51، للعامل بالأجر الشهري: 15 يوماً عن كل سنة من السنوات الخمس الأولى، وشهر كامل عن كل سنة بعدها، بحد أقصى أجر سنة ونصف. وتُخفَّض المكافأة عند الاستقالة وفق المادة 53." },
      { q: "متى يحق للشركة المطالبة بتعويض من الموظف؟", a: "في حالات الاستقالة المخلّة بشروط التدريب، أو الإضرار بمصلحة الشركة، أو الإفشاء المتعمّد لأسرارها." },
    ],
    faqEn: [
      { q: "What rights apply on unfair dismissal?", a: "Full end-of-service indemnity, accrued leave pay, and compensation for unfair dismissal assessed by the court under Article 46." },
      { q: "How is end-of-service calculated?", a: "Article 51, monthly-paid workers: 15 days per year for the first 5 years, then one month per year; capped at 18 months' pay. Reduced on resignation under Article 53." },
      { q: "When can an employer claim damages?", a: "On breach of training obligations, harm to firm interests, or willful disclosure of trade secrets." },
    ],
  },
  {
    slug: "corporate-law",
    icon: "Building2",
    titleAr: "القضايا التجارية والشركات",
    titleEn: "Commercial & Corporate",
    seoTitleAr: "محامي شركات في الكويت | تأسيس، اندماج، نزاعات تجارية، حوكمة",
    seoTitleEn: "Kuwait Corporate Lawyer | Incorporation, M&A, Commercial Disputes",
    metaAr:
      "خدمات قانونية للشركات في الكويت: تأسيس، اندماج، حوكمة، نزاعات المساهمين، عقود تجارية، وفقاً لقانون الشركات رقم 1 لسنة 2016.",
    metaEn:
      "Corporate legal services in Kuwait — incorporation, M&A, governance, shareholder disputes, commercial contracts under Companies Law No. 1 of 2016.",
    teaserAr: "نحمي شركتك من التأسيس حتى أعقد النزاعات التجارية.",
    teaserEn: "We protect your business from incorporation to the most complex commercial disputes.",
    introAr:
      "نقدّم استشارات قانونية متكاملة للشركات في الكويت وفقاً لقانون الشركات رقم 1 لسنة 2016 وتعديلاته، تشمل التأسيس، الحوكمة، الاندماج، نزاعات المساهمين، وصياغة العقود التجارية الكبرى.",
    introEn:
      "Full-service corporate counsel under Kuwait Companies Law No. 1 of 2016 — incorporation, governance, M&A, shareholder disputes, and complex commercial drafting.",
    includesAr: [
      "تأسيس شركات ذات مسؤولية محدودة وشركات مساهمة",
      "اتفاقيات المساهمين والمؤسسين",
      "الاندماج والاستحواذ والتمويلات",
      "الحوكمة المؤسسية والامتثال",
      "نزاعات المساهمين والمديرين",
      "العقود التجارية والوكالات",
      "تصفية الشركات وإعادة الهيكلة",
    ],
    includesEn: [
      "LLC and JSC incorporation",
      "Founder & shareholder agreements",
      "M&A and financing transactions",
      "Corporate governance & compliance",
      "Shareholder and director disputes",
      "Commercial contracts and agencies",
      "Liquidation and restructuring",
    ],
    documentsAr: [
      "السجل التجاري وشهادة المخالفات",
      "النظام الأساسي للشركة",
      "محاضر الجمعية العمومية الأخيرة",
      "البيانات المالية المدققة",
      "أي عقود محل النزاع",
    ],
    documentsEn: [
      "Commercial registry & violations certificate",
      "Articles of association",
      "Recent general assembly minutes",
      "Audited financial statements",
      "Any disputed contracts",
    ],
    processAr: [
      { step: "1", title: "تحليل قانوني شامل", body: "فحص المستندات وتحديد المخاطر القانونية." },
      { step: "2", title: "صياغة الحلول", body: "اقتراح حلول تتوافق مع أهدافك التجارية." },
      { step: "3", title: "التنفيذ القانوني", body: "تنفيذ المعاملات أمام كافة الجهات الرسمية." },
      { step: "4", title: "متابعة مستمرة", body: "مرافقة قانونية مستمرة عبر المستشار المعتمد." },
    ],
    processEn: [
      { step: "1", title: "Legal due diligence", body: "Examine docs, surface risks, scope the matter." },
      { step: "2", title: "Solution drafting", body: "Commercially literate, statutorily defensible." },
      { step: "3", title: "Execution", body: "Run filings before MOCI, registry, and any regulator." },
      { step: "4", title: "Ongoing counsel", body: "Retainer-based partnership over time." },
    ],
    faqAr: [
      { q: "ما الفرق بين ذ.م.م والشركة المساهمة؟", a: "الشركة ذات المسؤولية المحدودة تناسب المشاريع الصغيرة والمتوسطة، وتكون مسؤولية الشريك فيها بقدر حصته. أما المساهمة المقفلة فتتطلب رأس مال أعلى ومجلس إدارة. نحدد لك الشكل الأنسب ومتطلبات رأس المال الحالية وفق قانون الشركات ولائحته التنفيذية." },
      { q: "كم يستغرق تأسيس شركة في الكويت؟", a: "في المتوسط 2-6 أسابيع للذ.م.م مع كل التراخيص، وأطول للشركات المساهمة وفق رأس المال وتوافق الشركاء." },
      { q: "هل أحتاج محامياً عند توقيع عقد تجاري؟", a: "نعم، وننصح بذلك بشدة. مراجعة قانونية مسبقة توفر آلاف الدنانير في النزاعات لاحقاً وتضمن صياغة شروط الفسخ والتحكيم بطريقة تحميك." },
    ],
    faqEn: [
      { q: "LLC vs. closed JSC?", a: "An LLC suits small and mid-sized ventures, with liability limited to each partner's share. A closed JSC needs higher capital and a board. We confirm the right form and current capital requirements under the Companies Law and its regulations." },
      { q: "How long to incorporate in Kuwait?", a: "2-6 weeks for LLC with full licensing; longer for JSC depending on capital and partner alignment." },
      { q: "Do I need a lawyer to sign a commercial contract?", a: "Strongly recommended — pre-signing review saves thousands in disputes and ensures defensible termination & arbitration clauses." },
    ],
  },
  {
    slug: "civil-litigation",
    icon: "Scale",
    titleAr: "القضايا المدنية",
    titleEn: "Civil Litigation",
    seoTitleAr: "محامي قضايا مدنية في الكويت | عقود، مطالبات، تعويضات، تنفيذ",
    seoTitleEn: "Kuwait Civil Litigation Lawyer | Contracts, Damages, Enforcement",
    metaAr:
      "تمثيل قانوني في القضايا المدنية في الكويت: نزاعات العقود، المطالبات المالية، التعويض، الفسخ، التنفيذ، وفقاً للقانون المدني الكويتي.",
    metaEn:
      "Civil litigation representation in Kuwait — contract disputes, monetary claims, damages, rescission, enforcement under the Kuwaiti Civil Code.",
    teaserAr: "خبرة في النزاعات المدنية أمام كل درجات التقاضي.",
    teaserEn: "Civil disputes mastered at every level of Kuwaiti litigation.",
    introAr:
      "نمثّل عملاءنا في قضايا العقود، التعويضات، الإخلاء، المطالبات المالية، والنزاعات المدنية بكافة صورها أمام محاكم أول درجة، الاستئناف، والتمييز.",
    introEn:
      "We represent clients in contracts, damages, eviction, monetary claims, and civil disputes before the Courts of First Instance, Appeal, and Cassation.",
    includesAr: [
      "نزاعات العقود وفسخها",
      "المطالبات المالية والديون",
      "التعويض عن الأضرار",
      "نزاعات الإيجار والإخلاء",
      "تنفيذ الأحكام والشيكات",
      "حماية الملكية والحيازة",
      "الدعاوى الكيدية والتشهير",
    ],
    includesEn: [
      "Contract disputes and rescission",
      "Monetary claims and debts",
      "Damages and compensation",
      "Lease disputes and eviction",
      "Judgment & cheque enforcement",
      "Property and possession protection",
      "Vexatious suits and defamation",
    ],
    documentsAr: [
      "العقد محل النزاع",
      "أي مراسلات أو إنذارات سابقة",
      "إيصالات الدفع وإثباتات الضرر",
      "الشهود (إن وجدوا)",
      "أحكام أو إجراءات سابقة",
    ],
    documentsEn: [
      "Contract in dispute",
      "Prior correspondence and notices",
      "Payment receipts, damage evidence",
      "Witnesses (if any)",
      "Prior judgments or procedures",
    ],
    processAr: [
      { step: "1", title: "تقييم قانوني", body: "فحص العقد، الوقائع، وحظوظ النجاح." },
      { step: "2", title: "الإنذار الرسمي", body: "إنذار رسمي يُعلن عن طريق وزارة العدل، ثم المطالبة القضائية التي تقطع التقادم." },
      { step: "3", title: "إقامة الدعوى", body: "صياغة الصحيفة وتسلسل المرافعات." },
      { step: "4", title: "الاستئناف والتنفيذ", body: "متابعة في جميع الدرجات حتى تحصيل الحق." },
    ],
    processEn: [
      { step: "1", title: "Legal review", body: "Contract, facts, prospects." },
      { step: "2", title: "Notarized notice", body: "Stop limitation; preserve rights." },
      { step: "3", title: "Filing", body: "Draft pleadings; manage hearings." },
      { step: "4", title: "Appeal & enforce", body: "Through Cassation to collection." },
    ],
    faqAr: [
      { q: "ما خطوات رفع دعوى مدنية في الكويت؟", a: "1) إنذار رسمي يُعلن عن طريق إدارة الإعلان بوزارة العدل. 2) تحرير صحيفة الدعوى. 3) دفع الرسوم وقيد القضية. 4) إعلان الخصم. 5) تبادل المذكرات. 6) المرافعة والحكم. 7) الاستئناف خلال 30 يوماً." },
      { q: "ما مدة التقاضي المدني؟", a: "في المتوسط 6-18 شهراً أمام أول درجة، و12 شهراً أمام الاستئناف، و12 شهراً أمام التمييز. الإجمالي قد يصل لـ 3 سنوات." },
      { q: "هل يمكن التنفيذ على أملاك المدين؟", a: "نعم، بعد صدور الحكم النهائي يمكن الحجز على الحسابات البنكية والعقارات والسيارات وفقاً لأحكام التنفيذ في قانون المرافعات." },
    ],
    faqEn: [
      { q: "Steps to file a civil case?", a: "1) Formal notice served through the Ministry of Justice. 2) Draft complaint. 3) Pay fees & file. 4) Serve. 5) Exchange briefs. 6) Hearing & judgment. 7) Appeal within 30 days." },
      { q: "Duration?", a: "6-18 months at first instance + 12 months appeal + 12 months Cassation. Up to 3 years total." },
      { q: "Can I attach debtor assets?", a: "Yes — after a final judgment: bank accounts, real estate, vehicles under the enforcement provisions of the Code of Civil Procedure." },
    ],
  },
  {
    slug: "criminal-defense",
    icon: "Shield",
    titleAr: "القضايا الجزائية",
    titleEn: "Criminal Defense",
    seoTitleAr: "محامي قضايا جزائية في الكويت | دفاع، براءة، استئناف، تمييز",
    seoTitleEn: "Criminal Defense Lawyer in Kuwait | Acquittal, Appeals, Cassation",
    metaAr:
      "محامٍ متخصص في القضايا الجزائية في الكويت لجرائم الياقات البيضاء، الجرائم الإلكترونية، الجرائم المخلة بالشرف، وفقاً لقانون الجزاء رقم 16 لسنة 1960.",
    metaEn:
      "Specialist criminal defense in Kuwait — white-collar, cybercrime, honor crimes — under Penal Code No. 16 of 1960.",
    teaserAr: "دفاع جزائي متكامل من مرحلة التحقيق حتى محكمة التمييز.",
    teaserEn: "Rigorous criminal defense from the first 24 hours to the Court of Cassation.",
    introAr:
      "نتولّى الدفاع الجزائي في جميع الجرائم وفقاً لقانون الجزاء رقم 16 لسنة 1960، وقانون الإجراءات والمحاكمات الجزائية رقم 17 لسنة 1960، وقانون مكافحة جرائم تقنية المعلومات رقم 63 لسنة 2015، منذ التحقيق أمام النيابة العامة أو الإدارة العامة للتحقيقات وحتى محكمة التمييز.",
    introEn:
      "Criminal defense under Penal Code 16/1960, Code of Criminal Procedure, and Cybercrime Law 63/2015 — from the investigation stage (Public Prosecution or General Department of Investigations) to Cassation.",
    includesAr: [
      "جرائم الياقات البيضاء والاحتيال",
      "الجرائم الإلكترونية والابتزاز",
      "جرائم الشيك بدون رصيد",
      "الجرائم المخلة بالشرف والأخلاق",
      "جرائم المخدرات والمسكرات",
      "حوادث المرور الجسيمة",
      "الاستئناف وطعون التمييز",
    ],
    includesEn: [
      "White-collar crimes and fraud",
      "Cybercrime and extortion",
      "Bounced cheque offenses",
      "Honor and morality offenses",
      "Drug & alcohol offenses",
      "Serious traffic incidents",
      "Appeals & Cassation review",
    ],
    documentsAr: [
      "البطاقة المدنية",
      "أمر الإحضار أو محضر الاستجواب",
      "أي تقارير طبية شرعية",
      "كافة المراسلات الإلكترونية",
      "شهود النفي",
    ],
    documentsEn: [
      "Civil ID",
      "Summons or interrogation record",
      "Any forensic medical reports",
      "All electronic correspondence",
      "Defense witnesses",
    ],
    processAr: [
      { step: "1", title: "حضور التحقيق", body: "حضور فوري معك أمام جهة التحقيق وضمان حقوقك." },
      { step: "2", title: "إعداد الدفاع", body: "بناء الدفوع الإجرائية والموضوعية." },
      { step: "3", title: "المحاكمة", body: "المرافعة أمام المحكمة الجزائية وتقديم الشهود." },
      { step: "4", title: "الاستئناف والتمييز", body: "الطعن في الأحكام بجميع درجاتها." },
    ],
    processEn: [
      { step: "1", title: "Custody attendance", body: "Immediate prosecutor-stage representation." },
      { step: "2", title: "Defense build-out", body: "Procedural & substantive defenses." },
      { step: "3", title: "Trial", body: "Plead before the criminal court; produce witnesses." },
      { step: "4", title: "Appeal & Cassation", body: "Challenge at every level." },
    ],
    faqAr: [
      { q: "متى يكون الشيك جريمة؟", a: "وفق المادة 237 من قانون الجزاء (المعدلة بالقانون رقم 84 لسنة 2003)، يُجرّم إصدار شيك بدون رصيد قائم وقابل للسحب، أو سحب الرصيد بعد الإصدار، أو إعطاء أمر للبنك بعدم الصرف لغير الأسباب القانونية." },
      { q: "كم مدة الاستئناف الجزائي؟", a: "مواعيد الطعن قصيرة وتبدأ من تاريخ صدور الحكم أو إعلانه بحسب نوعه، وفوات الميعاد يُسقط الحق في الطعن. تواصل معنا فور صدور الحكم ونحسب لك الميعاد بدقة." },
      { q: "هل يحق لي الصمت أمام النيابة؟", a: "نعم، لك الحق المطلق في الصمت، ولا يجوز اعتبار صمتك دليلاً ضدك. ننصح بعدم الإدلاء بأي تصريح إلا بحضور محاميك." },
    ],
    faqEn: [
      { q: "When is a cheque a crime?", a: "Article 237 of the Penal Code (as amended by Law 84/2003) criminalizes issuing a cheque without sufficient funds, withdrawing them after issuance, or instructing the bank not to pay without a legal reason." },
      { q: "Appeal windows?", a: "Deadlines are short and run from the judgment date or its service, depending on the judgment type; missing one forfeits the appeal. Contact us as soon as judgment is issued and we will calculate the exact deadline." },
      { q: "Right to silence?", a: "Absolute. Your silence cannot be used against you. Do not make any statement without counsel." },
    ],
  },
  {
    slug: "contracts",
    icon: "FileText",
    titleAr: "الشركات والعقود",
    titleEn: "Contracts & Drafting",
    seoTitleAr: "صياغة ومراجعة العقود في الكويت | عقود تجارية، توظيف، توريد، شراكة",
    seoTitleEn: "Contract Drafting & Review in Kuwait | Commercial, Employment, Supply, Partnership",
    metaAr:
      "صياغة ومراجعة العقود التجارية، عقود التوظيف، عقود التوريد، اتفاقيات الشراكة وفقاً للقانون الكويتي. حماية كاملة لحقوقك التعاقدية.",
    metaEn:
      "Commercial, employment, supply, and partnership contract drafting & review under Kuwaiti law — full protection of your contractual position.",
    teaserAr: "عقد صحيح اليوم يحميك من نزاع مكلف غداً.",
    teaserEn: "A precise contract today prevents a costly dispute tomorrow.",
    introAr:
      "نصيغ ونراجع كافة أنواع العقود وفقاً للقانون المدني الكويتي وقانون التجارة، مع التركيز على شروط الفسخ، التحكيم، الاختصاص، التعويض، والقوة القاهرة بشكل يحميك في المحاكم.",
    introEn:
      "We draft & review all contract types under the Kuwaiti Civil Code and Commercial Code — termination, arbitration, jurisdiction, indemnity, and force majeure crafted to survive judicial review.",
    includesAr: [
      "العقود التجارية والتوريد",
      "عقود التوظيف وكبار التنفيذيين",
      "اتفاقيات المساهمين والشراكة",
      "عقود التراخيص والوكالات",
      "عقود الإيجار والعقار",
      "اتفاقيات السرية وعدم المنافسة",
      "عقود مزودي خدمات الذكاء الاصطناعي والتقنية",
    ],
    includesEn: [
      "Commercial supply contracts",
      "Employment & executive agreements",
      "Shareholder & partnership agreements",
      "License & agency contracts",
      "Real estate & lease agreements",
      "NDAs and non-compete agreements",
      "AI / technology services contracts",
    ],
    documentsAr: [
      "مسودة العقد الحالية (إن وجدت)",
      "أهداف العقد التجارية بشكل واضح",
      "مستندات الأطراف القانونية",
      "أي عقود ذات صلة سابقة",
    ],
    documentsEn: [
      "Existing contract draft (if any)",
      "Clear commercial objectives",
      "Counterparty legal documents",
      "Any related prior agreements",
    ],
    processAr: [
      { step: "1", title: "جمع المتطلبات", body: "نفهم أهدافك التجارية والمخاطر المحتملة." },
      { step: "2", title: "الصياغة الأولية", body: "نصوغ العقد بدقة قانونية وتفصيل تجاري." },
      { step: "3", title: "التفاوض", body: "نتفاوض على البنود نيابة عنك إن أردت." },
      { step: "4", title: "التوقيع والتوثيق", body: "نوثّق العقد، ونسلّمك النسخ الموقعة ونحتفظ بنسخة لدينا." },
    ],
    processEn: [
      { step: "1", title: "Requirements gathering", body: "Commercial objectives & risks." },
      { step: "2", title: "First draft", body: "Legally precise, commercially aware." },
      { step: "3", title: "Negotiation", body: "Run negotiations on your behalf." },
      { step: "4", title: "Signature & vault", body: "Execute, notarize, and retain signed originals." },
    ],
    faqAr: [
      { q: "الفرق بين الإنذار والفسخ في العقود؟", a: "الإنذار: تنبيه رسمي للطرف الآخر بالتنفيذ خلال مهلة محددة. الفسخ: إنهاء العقد بحكم قضائي أو باتفاق الطرفين بعد عدم استجابة الإنذار. الفسخ القضائي يستلزم سبق الإنذار في معظم الحالات." },
      { q: "هل يلزم توثيق العقد؟", a: "العقود التجارية صحيحة بمجرد التوقيع، لكن توثيقها لدى إدارة التوثيق بوزارة العدل أو الجهات المختصة يعزز قوتها الإثباتية ويسرّع التنفيذ." },
      { q: "كيف تحمي نفسك قبل التوقيع؟", a: "1) مراجعة قانونية مستقلة. 2) التأكد من صلاحية الموقّع عن الشركة الأخرى. 3) شرط تحكيم واضح أو اختصاص قضائي محدد. 4) شرط فسخ متبادل. 5) شروط القوة القاهرة." },
    ],
    faqEn: [
      { q: "Warning vs. rescission?", a: "Warning: formal notice to perform within a set period. Rescission: termination by court or mutual agreement after warning is ignored. Judicial rescission usually requires prior warning." },
      { q: "Notarization required?", a: "Commercial contracts are valid on signature, but notarization strengthens evidentiary weight and speeds enforcement." },
      { q: "How to protect yourself pre-signing?", a: "1) Independent review. 2) Verify signing authority. 3) Clear arbitration/jurisdiction clause. 4) Mutual termination clause. 5) Force majeure terms." },
    ],
  },
  {
    slug: "arbitration",
    icon: "Gavel",
    titleAr: "التحكيم والمنازعات",
    titleEn: "Arbitration & Dispute Resolution",
    seoTitleAr: "محامي تحكيم في الكويت | تحكيم تجاري محلي ودولي، KCAC، ICC، DIAC",
    seoTitleEn: "Arbitration Lawyer in Kuwait | International Commercial Arbitration",
    metaAr:
      "تحكيم تجاري محلي ودولي أمام مركز الكويت للتحكيم التجاري KCAC، وغرفة التجارة الدولية ICC، ومركز دبي للتحكيم الدولي DIAC. تنفيذ أحكام التحكيم في الكويت.",
    metaEn:
      "Domestic & international commercial arbitration before the Kuwait Commercial Arbitration Centre (KCAC), ICC and DIAC — and enforcement of arbitral awards in Kuwait.",
    teaserAr: "حلّ النزاعات بسرعة وسرية تامة عبر التحكيم.",
    teaserEn: "Resolve disputes swiftly and confidentially through arbitration.",
    introAr:
      "نتولّى التحكيم التجاري الداخلي والدولي وفقاً لأحكام التحكيم في قانون المرافعات المدنية والتجارية، والقانون رقم 11 لسنة 1995 بشأن التحكيم القضائي، واتفاقية نيويورك لتنفيذ أحكام التحكيم الأجنبية، أمام أبرز المراكز: مركز الكويت للتحكيم التجاري التابع لغرفة تجارة وصناعة الكويت (KCAC)، وغرفة التجارة الدولية ICC، ومركز دبي للتحكيم الدولي DIAC.",
    introEn:
      "Commercial arbitration under the arbitration chapter of the Code of Civil and Commercial Procedure and Judicial Arbitration Law 11/1995 — before KCAC, ICC, DIAC and other major centres. Enforcement under the New York Convention.",
    includesAr: [
      "إعداد طلبات التحكيم والردود",
      "تعيين المحكمين والاختصاص",
      "إدارة جلسات التحكيم",
      "تنفيذ أحكام التحكيم الأجنبية",
      "نزاعات البناء والإنشاءات",
      "تحكيم الاستثمار الأجنبي",
      "صياغة شروط التحكيم في العقود",
    ],
    includesEn: [
      "Requests for arbitration & responses",
      "Arbitrator appointment & jurisdiction",
      "Hearing management",
      "Foreign award enforcement",
      "Construction disputes",
      "Foreign investment arbitration",
      "Drafting arbitration clauses",
    ],
    documentsAr: [
      "العقد المتضمن شرط التحكيم",
      "كافة المراسلات والمستندات الفنية",
      "تقارير الخبراء (إن وجدت)",
      "أحكام التحكيم السابقة",
    ],
    documentsEn: [
      "Contract with arbitration clause",
      "All correspondence & technical docs",
      "Expert reports (if any)",
      "Prior arbitral awards",
    ],
    processAr: [
      { step: "1", title: "تحليل الشرط التحكيمي", body: "تحديد المركز التحكيمي والقانون الواجب التطبيق." },
      { step: "2", title: "تقديم الطلب", body: "صياغة طلب التحكيم وتعيين المحكم." },
      { step: "3", title: "الجلسات والمذكرات", body: "إدارة كاملة لجلسات التحكيم." },
      { step: "4", title: "تنفيذ الحكم", body: "تنفيذ حكم التحكيم في الكويت أو الخارج." },
    ],
    processEn: [
      { step: "1", title: "Clause analysis", body: "Identify centre and governing law." },
      { step: "2", title: "Filing", body: "Draft RFA; appoint arbitrators." },
      { step: "3", title: "Hearings", body: "Full management of arbitration proceedings." },
      { step: "4", title: "Enforcement", body: "Local or cross-border enforcement of the award." },
    ],
    faqAr: [
      { q: "متى يُفضّل التحكيم على القضاء؟", a: "عند الحاجة للسرية، تخصص المحكّمين، السرعة (سنة - سنتين)، وإمكانية تنفيذ الحكم دولياً بسهولة بموجب اتفاقية نيويورك." },
      { q: "هل التحكيم ملزم؟", a: "نعم، حكم التحكيم ملزم وقابل للتنفيذ بعد وضع الصيغة التنفيذية عليه. ولا يُستأنف كأصل عام إلا إذا اتفق الأطراف على ذلك، ويجوز طلب بطلانه في الحالات التي حددها قانون المرافعات." },
      { q: "كم تكلفة التحكيم؟", a: "تعتمد على قيمة النزاع وجدول رسوم مركز التحكيم المختار وأتعاب المحكّمين. نعطيك تقديراً مكتوباً بعد مراجعة العقد وشرط التحكيم." },
    ],
    faqEn: [
      { q: "When prefer arbitration?", a: "When you need confidentiality, specialist arbitrators, speed (1-2 years), and cross-border enforceability under the New York Convention." },
      { q: "Is the award binding?", a: "Yes — binding and enforceable once an enforcement order is issued. As a rule it is not appealable unless the parties agreed otherwise, and it may be set aside only on the grounds listed in the Code of Civil Procedure." },
      { q: "Cost?", a: "It depends on the amount in dispute, the chosen centre's fee schedule and arbitrator fees. We give you a written estimate after reviewing the contract and arbitration clause." },
    ],
  },
  {
    slug: "business-consultation",
    icon: "Users",
    titleAr: "الاستشارات القانونية للشركات",
    titleEn: "Business Legal Counsel",
    seoTitleAr: "مستشار قانوني للشركات في الكويت | عقد سنوي، استشارة دائمة، مذكرات",
    seoTitleEn: "Retained Corporate Counsel in Kuwait | Annual Retainer, Standing Advice",
    metaAr:
      "خدمة المستشار القانوني الدائم للشركات في الكويت: مراجعة العقود، الاستشارات اليومية، الامتثال، وتمثيل قانوني مستمر.",
    metaEn:
      "Outsourced general counsel for Kuwait businesses — contract review, day-to-day advisory, compliance, and ongoing representation.",
    teaserAr: "مستشار قانوني دائم لشركتك بكلفة أقل من توظيف محامٍ داخلي.",
    teaserEn: "A retained general counsel for your business — at a fraction of an in-house lawyer's cost.",
    introAr:
      "نوفّر لشركتك خدمة المستشار القانوني الدائم بعقد سنوي يشمل: مراجعة العقود، الاستشارات اليومية، الامتثال للأنظمة، إعداد المذكرات الداخلية، التفاوض مع الموردين والعملاء، ومتابعة النزاعات.",
    introEn:
      "An annual retainer covering: contract review, daily advice, regulatory compliance, internal memos, supplier/customer negotiation, and dispute management.",
    includesAr: [
      "مراجعة العقود غير المحدودة",
      "الاستشارات الهاتفية والمكتبية",
      "إعداد المذكرات والآراء القانونية",
      "متابعة الامتثال للقوانين الجديدة",
      "تدريب الموظفين على القضايا القانونية",
      "تمثيل في النزاعات البسيطة",
      "ساعات شهرية مخصصة لشركتك",
    ],
    includesEn: [
      "Unlimited contract review",
      "Phone & in-person advisory",
      "Legal memoranda & opinions",
      "Regulatory compliance tracking",
      "Staff legal training",
      "Representation in minor disputes",
      "Dedicated monthly hours",
    ],
    documentsAr: [
      "السجل التجاري وعقد التأسيس",
      "نموذج العقود الحالية",
      "ميزانية الخدمات القانونية",
      "الهيكل التنظيمي للشركة",
    ],
    documentsEn: [
      "Commercial registry & MOA",
      "Current contract templates",
      "Legal services budget",
      "Org chart",
    ],
    processAr: [
      { step: "1", title: "تقييم الاحتياجات", body: "نحلّل حجم النشاط والمخاطر القانونية." },
      { step: "2", title: "اقتراح الباقة", body: "نقترح باقة شهرية أو سنوية مناسبة." },
      { step: "3", title: "الانطلاق", body: "تخصيص محامٍ مسؤول عن حسابك مباشرة." },
      { step: "4", title: "متابعة مستمرة", body: "تقرير شهري ومراجعة ربعية للأداء." },
    ],
    processEn: [
      { step: "1", title: "Needs assessment", body: "Volume, exposure, risk profile." },
      { step: "2", title: "Package proposal", body: "Monthly or annual fixed-fee plan." },
      { step: "3", title: "Onboarding", body: "Dedicated relationship partner." },
      { step: "4", title: "Ongoing", body: "Monthly report + quarterly review." },
    ],
    faqAr: [
      { q: "ما أهمية الاستشارة القانونية قبل تأسيس شركة؟", a: "يحدد المستشار القانوني الشكل الأمثل للشركة، ويصيغ اتفاقية المؤسسين، يضع آلية فض النزاعات بين الشركاء، ويحمي رأس مالك من المخاطر القانونية المعتادة." },
      { q: "كم تكلفة المستشار الدائم؟", a: "تختلف بحسب حجم النشاط. تبدأ باقات الشركات من 75 د.ك شهرياً، وباقة المكتب الشهرية 350 د.ك، ونصمم باقات خاصة للمجموعات الكبيرة. التفاصيل في صفحة الاشتراكات." },
      { q: "هل يشمل ذلك التمثيل في المحاكم؟", a: "يشمل الاستشارة والمذكرات والمتابعة. التمثيل في المحاكم في القضايا الجوهرية يكون بأتعاب إضافية متفق عليها مسبقاً." },
    ],
    faqEn: [
      { q: "Why pre-incorporation counsel?", a: "Optimal entity choice, founders' agreement, dispute-resolution mechanic, and protection from common legal exposures." },
      { q: "Retainer cost?", a: "Tiered by business size — business plans start at KWD 75/month, the in-house plan is KWD 350/month, and large groups get tailored arrangements. See the Subscriptions page." },
      { q: "Includes litigation?", a: "Includes advice, drafting, and procedural follow-up. Major court representation is billed separately by pre-agreed scope." },
    ],
  },
  {
    slug: "real-estate",
    icon: "Home",
    titleAr: "العقارات والمقاولات",
    titleEn: "Real Estate & Construction",
    seoTitleAr: "محامي عقارات في الكويت | بيع وشراء، إيجارات، مقاولات، طابو",
    seoTitleEn: "Real Estate Lawyer in Kuwait | Sale, Lease, Construction, Title",
    metaAr:
      "خدمات قانونية للعقارات في الكويت: بيع وشراء، إيجارات، مقاولات، فحص الملكية لدى التسجيل العقاري، نزاعات المطورين، وفقاً للمرسوم بقانون 74/1979.",
    metaEn:
      "Kuwait real estate legal services — sale & purchase, leases, construction, real-estate registry title checks, developer disputes under Decree-Law 74/1979.",
    teaserAr: "أمان قانوني كامل في كل صفقة عقارية.",
    teaserEn: "Total legal certainty on every real-estate deal.",
    introAr:
      "نتعامل مع كافة المعاملات العقارية وفقاً للقانون المدني الكويتي وقانون إيجار العقارات وقانون التسجيل العقاري، تشمل البيع والشراء، الإيجار، التطوير العقاري، المقاولات، ومنازعات المساحة والملكية.",
    introEn:
      "All real-estate transactions under the Civil Code, lease law, and the Real Estate Registration Law — sale, lease, development, construction, and boundary or title disputes.",
    includesAr: [
      "بيع وشراء العقارات",
      "عقود الإيجار التجارية والسكنية",
      "نزاعات الإخلاء وزيادة الإيجار",
      "عقود المقاولات وإدارة المشاريع",
      "فحص الملكية والتسجيل العقاري",
      "نزاعات المطورين والمشترين",
      "تملك الأجانب وفقاً للقانون 74/1979",
    ],
    includesEn: [
      "Property purchase & sale",
      "Residential & commercial leases",
      "Eviction & rent-increase disputes",
      "Construction contracts & project management",
      "Real-estate registry title checks",
      "Developer-buyer disputes",
      "Foreign ownership under Decree-Law 74/1979",
    ],
    documentsAr: [
      "وثيقة ملكية العقار",
      "العقد محل التعامل",
      "رخصة البناء (للمقاولات)",
      "مخططات المساحة",
      "أي مراسلات مع البلدية أو إدارة التسجيل العقاري",
    ],
    documentsEn: [
      "Title deed",
      "Subject contract",
      "Building permit (for construction)",
      "Survey plans",
      "Correspondence with the municipality or the Real Estate Registry",
    ],
    processAr: [
      { step: "1", title: "الفحص القانوني", body: "فحص الملكية والقيود لدى إدارة التسجيل العقاري." },
      { step: "2", title: "صياغة العقد", body: "صياغة بنود البيع/الإيجار وحماية حقوقك." },
      { step: "3", title: "التوثيق", body: "تسجيل المعاملة لدى إدارة التسجيل العقاري والتوثيق والجهات الرسمية." },
      { step: "4", title: "متابعة التسليم", body: "ضمان التسليم المطابق للمواصفات والشروط." },
    ],
    processEn: [
      { step: "1", title: "Due diligence", body: "Title and encumbrance check at the Real Estate Registry." },
      { step: "2", title: "Drafting", body: "Sale/lease clauses that protect you." },
      { step: "3", title: "Registration", body: "Register with the Real Estate Registration & Documentation Dept." },
      { step: "4", title: "Handover", body: "Confirm conforming delivery." },
    ],
    faqAr: [
      { q: "كيف أتأكد من سلامة الملكية قبل الشراء؟", a: "1) استخراج شهادة رسمية من إدارة التسجيل العقاري. 2) التأكد من خلوها من الرهون والقيود. 3) مطابقة الأبعاد مع المساحة الفعلية. 4) فحص الالتزامات البلدية والمخالفات." },
      { q: "هل يمكن للأجنبي تملك عقار في الكويت؟", a: "وفقاً للمرسوم بقانون 74 لسنة 1979، تملك الأجانب مقيّد بشدة. متاح للجنسيات الخليجية في حدود معينة، ولبعض الفئات الاستثنائية بقرار من مجلس الوزراء." },
      { q: "ما الفرق بين الإيجار التجاري والسكني؟", a: "يخضع الإيجار السكني والتجاري كلاهما للمرسوم بقانون رقم 35 لسنة 1978 في شأن إيجار العقارات وتعديلاته، وتختلف بعض الأحكام بحسب الغرض من الإيجار. نوضح لك ما ينطبق على عقدك في الاستشارة." },
    ],
    faqEn: [
      { q: "Verify title before purchase?", a: "1) Official Real Estate Registry certificate. 2) Confirm free of liens. 3) Match plans to actual area. 4) Municipal obligations & violations check." },
      { q: "Can foreigners own property?", a: "Decree-Law 74/1979 sharply limits it. GCC nationals within set limits; certain categories by cabinet decree." },
      { q: "Commercial vs. residential lease?", a: "Both residential and commercial leases fall under Decree-Law 35/1978 on Real Estate Leases, with some rules differing by purpose. We explain what applies to your lease." },
    ],
  },
  {
    slug: "intellectual-property",
    icon: "Lightbulb",
    titleAr: "الملكية الفكرية",
    titleEn: "Intellectual Property",
    seoTitleAr: "محامي ملكية فكرية في الكويت | علامات تجارية، براءات اختراع، حقوق نشر",
    seoTitleEn: "Kuwait IP Lawyer | Trademarks, Patents, Copyright",
    metaAr:
      "حماية وتسجيل العلامات التجارية وبراءات الاختراع وحقوق النشر في الكويت ودول مجلس التعاون. مكافحة التقليد والاعتداء على العلامة.",
    metaEn:
      "Trademark, patent, and copyright registration & enforcement in Kuwait and the GCC. Anti-counterfeiting and infringement actions.",
    teaserAr: "نحمي أصولك الفكرية محلياً وخليجياً.",
    teaserEn: "We protect your intellectual assets locally and across the GCC.",
    introAr:
      "نقدّم خدمات الملكية الفكرية الكاملة وفقاً لقانون (نظام) العلامات التجارية لدول مجلس التعاون المعمول به في الكويت، والقانون رقم 75 لسنة 2019 بشأن حقوق المؤلف والحقوق المجاورة، شاملاً التسجيل والحماية والتقاضي ضد التقليد.",
    introEn:
      "Full IP services under the GCC Trademark Law as applied in Kuwait and Copyright Law 75/2019 — registration, protection, and litigation against counterfeiting.",
    includesAr: [
      "تسجيل العلامات التجارية محلياً وخليجياً",
      "تسجيل براءات الاختراع",
      "حماية حقوق المؤلف والنشر",
      "اتفاقيات الترخيص والنقل",
      "مكافحة التقليد والتزوير",
      "نزاعات الأسماء التجارية والنطاقات",
      "التحقق من الملكية الفكرية في صفقات الاستحواذ",
    ],
    includesEn: [
      "Trademark registration (Kuwait & GCC)",
      "Patent registration",
      "Copyright protection",
      "Licensing & assignment agreements",
      "Anti-counterfeiting enforcement",
      "Trade name & domain disputes",
      "IP due diligence in M&A",
    ],
    documentsAr: [
      "نموذج العلامة بدقة عالية",
      "قائمة الفئات المطلوبة",
      "السجل التجاري للشركة",
      "أي حقوق ملكية سابقة",
    ],
    documentsEn: [
      "High-resolution mark sample",
      "Requested class list",
      "Company commercial registry",
      "Any prior IP rights",
    ],
    processAr: [
      { step: "1", title: "البحث الأولي", body: "البحث في سجلات الملكية لضمان عدم التعارض." },
      { step: "2", title: "تقديم الطلب", body: "تقديم طلب التسجيل لدى وزارة التجارة." },
      { step: "3", title: "النشر والاعتراض", body: "النشر في الجريدة الرسمية ومتابعة الاعتراضات." },
      { step: "4", title: "إصدار الشهادة", body: "استلام شهادة التسجيل وحفظها." },
    ],
    processEn: [
      { step: "1", title: "Search", body: "Conflict search across IP registries." },
      { step: "2", title: "Filing", body: "Application at the Ministry of Commerce." },
      { step: "3", title: "Publication", body: "Gazette publication; manage oppositions." },
      { step: "4", title: "Certificate", body: "Issuance and safekeeping." },
    ],
    faqAr: [
      { q: "كم مدة حماية العلامة التجارية؟", a: "10 سنوات قابلة للتجديد لفترات مماثلة بشكل غير محدود. التجديد يجب أن يتم خلال السنة الأخيرة من فترة الحماية." },
      { q: "هل تسجيل العلامة في الكويت يحميها في الخليج؟", a: "لا. رغم توحيد قانون العلامات التجارية بين دول مجلس التعاون، يتطلب كل بلد تسجيلاً مستقلاً. نتولى التسجيل في الدول التي تحتاجها." },
      { q: "ماذا أفعل عند الاعتداء على علامتي؟", a: "1) إنذار رسمي للمعتدي. 2) شكوى إدارية في وزارة التجارة. 3) دعوى قضائية بالتعويض والمصادرة. 4) إجراءات جمركية لمنع الاستيراد." },
    ],
    faqEn: [
      { q: "Trademark duration?", a: "10 years, indefinitely renewable. Renewal must occur in the last year of the protection term." },
      { q: "Does Kuwait registration cover GCC?", a: "No. Although the GCC trademark law is unified, each state requires its own registration. We file in every state you need." },
      { q: "What to do on infringement?", a: "1) Formal warning. 2) Administrative complaint at MOCI. 3) Civil suit for damages & seizure. 4) Customs measures to block imports." },
    ],
  },
];

export const getServiceBySlug = (slug) =>
  SERVICES.find((s) => s.slug === slug) || null;

// Practice categories used by the booking form & AI assistant.
export const BOOKING_CATEGORIES = [
  { value: "family", labelAr: "أحوال شخصية", labelEn: "Family / Personal Status" },
  { value: "labor", labelAr: "عمالي", labelEn: "Labor" },
  { value: "commercial", labelAr: "تجاري", labelEn: "Commercial" },
  { value: "civil", labelAr: "مدني", labelEn: "Civil" },
  { value: "criminal", labelAr: "جزائي", labelEn: "Criminal" },
  { value: "corporate", labelAr: "شركات", labelEn: "Corporate" },
  { value: "contracts", labelAr: "عقود", labelEn: "Contracts" },
  { value: "real_estate", labelAr: "عقارات", labelEn: "Real Estate" },
  { value: "ip", labelAr: "ملكية فكرية", labelEn: "Intellectual Property" },
  { value: "arbitration", labelAr: "تحكيم", labelEn: "Arbitration" },
  { value: "other", labelAr: "أخرى", labelEn: "Other" },
];

export const BOOKING_METHODS = [
  { value: "office", labelAr: "في المكتب", labelEn: "In office" },
  { value: "phone", labelAr: "اتصال هاتفي", labelEn: "Phone call" },
  { value: "video", labelAr: "Zoom / Google Meet", labelEn: "Zoom / Google Meet" },
  { value: "whatsapp", labelAr: "مكالمة واتساب", labelEn: "WhatsApp call" },
];
